import { createContext, ReactNode, useState } from "react";

export type LayoutBarContextType = {
    isLayoutBarActive: boolean;
    updateIsLayoutBarActive: Function;
    updateContent: Function;
    setWidth: Function;
    content: ReactNode;
    width: any;
    //  handle navBar
    active: string | boolean;
    setActive: (v: string | boolean) => void;
};

export const LayoutBarContext = createContext<LayoutBarContextType>({
    isLayoutBarActive: false,
    updateIsLayoutBarActive: (value: boolean) => {},
    updateContent: (value: any) => {},
    setWidth: (value: any) => {},
    content: null,
    width: null,
    active: "",
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setActive: (value: string | boolean) => {},
});

export const LayoutBarContextProvider = (props: any) => {
    const [isLayoutBarActive, setIsLayoutBarActive] = useState<boolean>(false);
    const [content, setContent] = useState<ReactNode | null>(null);
    const [width, setWidth] = useState<any>(null);
    const [active, setActive] = useState<string | boolean>(false);

    const updateIsLayoutBarActive = (value: boolean) => {
        setIsLayoutBarActive(value);
    };

    const updateContent = (value: ReactNode) => {
        setContent(value);
    };

    return (
        <LayoutBarContext.Provider
            value={{
                isLayoutBarActive,
                updateIsLayoutBarActive,
                updateContent,
                content,
                width,
                setWidth,
                setActive,
                active,
            }}
        >
            {props.children}
        </LayoutBarContext.Provider>
    );
};
